import { useFormik } from "formik";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TitleHeader } from "../../Common/Components/TitleHeader";
import { ChangeEmailStatus } from "../../Services/MainService";

export const NotificationsPermission = () => {
  const [loading, setLoading] = useState(false);
  const [ci, setCi] = useState(true);
  const customer = useSelector((x) => x.Customer);
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      email_notifications: false,
    },
  });
  React.useEffect(() => {
    if (customer) {
      formik.setFieldValue(
        "email_notifications",
        Boolean(customer.emailStatus)
      );
      setCi(false);
    }
  }, [customer]);
  const handleChange = (e) => {
    setLoading(true);
    ChangeEmailStatus({
      status: Number(e),
    }).then(
      (res) => {
        console.log(res);
        setLoading(false);
        dispatch({
          type: "setCustomer",
          payload: {
            ...customer,
            emailStatus: Number(e),
          },
        });
      },
      (er) => {
        setLoading(false);
        console.warn(er);
      }
    );
  };
  return (
    <>
      <TitleHeader
        title="Notifications"
        subtitle="Control real-time updates on your laundry"
      />
      <div className="container py-5">
        {/* <div className="row justify-content-center">
          <div className="col-lg-7 col-md-8 col-12">
            <h4 className="fw-bold" style={{ color: "#656565" }}>
              Order Status Notifications
            </h4>
            <p>
              Keep me updated on my order status through in-app notifications.
            </p>
            <div className="d-flex align-items-center">
              <label htmlFor="" className="me-2">
                Enable in-app notifications
              </label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="app_notifications"
                  name="app_notifications"
                  checked={formik.values.app_notifications}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{ height: "2em", width: "3.3em" }}
                />
              </div>
            </div>
            <hr style={{ margin: "2.7rem 0px" }} />
          </div>
        </div> */}
        <div
          className="row justify-content-center align-items-center"
          style={{ minHeight: "26vh" }}
        >
          <div className="col-lg-7 col-md-8 col-12">
            <h4 className="fw-bold" style={{ color: "#656565" }}>
              Email Notifications
            </h4>
            <p>
              Send Notifications on my registered email address for order
              updates.
            </p>
            <div className="d-flex align-items-center">
              <label htmlFor="" className="me-2">
                Enable email notifications
              </label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="email_notifications"
                  name="email_notifications"
                  checked={formik.values.email_notifications}
                  onChange={(e) => {
                    handleChange(e.target.checked);
                  }}
                  onBlur={formik.handleBlur}
                  style={{ height: "2em", width: "3.3em" }}
                  disabled={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
